import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import banner1 from "../assets/banners/1.jpg";
import banner2 from "../assets/banners/2.jpg";
import banner3 from "../assets/banners/3.jpg";
import banner4 from "../assets/banners/4.jpg";
import banner5 from "../assets/banners/5.jpg";


import banner11 from "../assets/banners/11.jpg";
import banner111 from "../assets/banners/111.jpg";

import banner22 from "../assets/banners/22.jpg";
import banner33 from "../assets/banners/33.jpg";
import banner44 from "../assets/banners/44.jpg";
import banner55 from "../assets/banners/55.jpg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './HomeStyle.css';

function Home() {
  const [showHeader, setShowHeader] = useState(false);

  // ✅ Toggle header visibility on scroll
  useEffect(() => {
    const handleScroll = () => {
      setShowHeader(window.scrollY > 500);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const heroSlides = [
    { image: banner1, buttonText: "Explore Our Services", buttonLink: "/services" },
    { image: banner2, buttonText: "Explore Our Services", buttonLink: "/services" },
    { image: banner3, buttonText: "Explore Our Services", buttonLink: "/services" },
    { image: banner4, buttonText: "Explore Our Services", buttonLink: "/services" },
    { image: banner5, buttonText: "Explore Our Services", buttonLink: "/services" },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: true,
  };

  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className=" hero-slider">
        <Slider {...sliderSettings}>
          {heroSlides.map((slide, index) => (
            <div key={index} className="hero-slide">
              <img src={slide.image} alt={`Slide ${index + 1}`} className="hero-image" />
              <div className=" hero-overlay">
              </div>
            </div>
          ))}
        </Slider>
      </section>


{/* Section */}
      <section className="w3-hide w3-row w3-padding-64">
        <div className="w3-col ">
          <div className="w3-col l6">
            <img src={banner11} alt="" className="hero-image" />
          
          </div>
          <div className="w3-col l5 w3-padding-64">
               <img src={banner111} alt="" className="hero-image" />
          
          </div>
        </div>
      </section>



{/* Section */}
      <section className="w3-hide w3-row w3-padding-64">
        <div className="w3-col ">
          <div className="w3-col l6 w3-right">
            <img src={banner11} alt="" className="hero-image" />
          
          </div>
          <div className="w3-col l5 ">
               <img src={banner111} alt="" className="hero-image" />
          
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
